import React, { useEffect, useState } from "react";
import { api, galleryImageUrl } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ImageOff } from "lucide-react";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
        <div className="max-w-2xl mb-10">
          <div className="text-xs font-mono uppercase tracking-widest text-sky-400 mb-3">Nossos trabalhos</div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white">Galeria de atendimentos</h1>
          <p className="mt-4 text-slate-300">Veja alguns dos serviços realizados pela nossa equipe.</p>
        </div>
        {items.length === 0 ? (
          <Card className="bg-slate-900/50 border-slate-800 p-16 flex flex-col items-center justify-center text-center" data-testid="gallery-empty">
            <ImageOff className="w-12 h-12 text-slate-600 mb-4" />
            <p className="text-slate-400">A galeria ainda está sendo preparada. Volte em breve!</p>
          </Card>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="gallery-grid">
            {items.map((g) => (
              <Card
                key={g.gallery_id}
                onClick={() => setSelected(g)}
                className="group cursor-pointer bg-slate-900/50 border-slate-800 overflow-hidden hover:border-sky-500/50 transition-all"
                data-testid={`gallery-item-${g.gallery_id}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={galleryImageUrl(g.gallery_id)} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-white truncate">{g.title}</h3>
                  {g.vehicle && <p className="text-xs text-sky-400 font-mono mt-1">{g.vehicle}</p>}
                </div>
              </Card>
            ))}
          </div>
        )}
      </section>

      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent className="bg-slate-900 border-sky-500/20 max-w-3xl">
          {selected && (
            <div>
              <img src={galleryImageUrl(selected.gallery_id)} alt={selected.title} className="w-full rounded-lg mb-4" />
              <h3 className="text-xl font-bold text-white">{selected.title}</h3>
              {selected.vehicle && <p className="text-sm text-sky-400 font-mono mt-1">{selected.vehicle}</p>}
              {selected.description && <p className="text-slate-300 mt-3">{selected.description}</p>}
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Footer />
    </div>
  );
}
